export const ZEFIX_UID_PATTERN = /^CHE-\d{3}\.\d{3}\.\d{3}$/;
export const ZEFIX_COUNTRY_CODE = 'CH';

/** Raw/plain UID pattern (no dashes or dots), as stored in zefix_uid internally. */
const ZEFIX_UID_PLAIN_PATTERN = /^CHE\d{9}$/;

/**
 * Formats a Zefix UID to the user-facing display format: CHE-XXX.XXX.XXX.
 * Accepts both the plain format (CHE107721785) and the already-formatted format (CHE-107.721.785).
 * Returns null for null/undefined input; returns the input unchanged if it is not a valid zefix UID.
 */
export function formatZefixUid(uid: string | null | undefined): string | null {
    if (!uid) return uid ?? null;
    const plain = uid.replace(/[-\.]/g, '');
    if (!ZEFIX_UID_PLAIN_PATTERN.test(plain)) return uid;
    return `${plain.slice(0, 3)}-${plain.slice(3, 6)}.${plain.slice(6, 9)}.${plain.slice(9, 12)}`;
}

/**
 * Strips a Zefix UID to the raw/plain format (CHE107721785) used for internal logic and API calls.
 * Accepts both the formatted (CHE-107.721.785) and already-plain format.
 * Returns null for null/undefined input; returns the input unchanged if it is not a valid zefix UID.
 */
export function stripZefixUid(uid: string | null | undefined): string | null {
    if (!uid) return uid ?? null;
    const plain = uid.replace(/[-\.]/g, '');
    if (!ZEFIX_UID_PLAIN_PATTERN.test(plain)) return uid;
    return plain;
}
